import React from "react";
import RotatedMarker from "../RotatedMarker";
import { Tooltip } from "react-leaflet";

export type MarkerData = {
    imei: string;
    lat: number;
    lng: number;
    yaw: number;
    isOnline: boolean;
}

interface ConsoleMapMarkerProps {
    marker: MarkerData;
    icon: L.Icon;
    onClick: (marker: MarkerData) => void;
    isOnline: boolean;
}

function ConsoleMapMarker({ marker, icon, onClick }: ConsoleMapMarkerProps) {
    return (
        <RotatedMarker
            key={marker.imei}
            position={[marker.lat, marker.lng]}
            icon={icon}
            rotationAngle={-marker.yaw}
            eventHandlers={{
                click: () => onClick(marker)
            }}
        >
            <Tooltip direction="bottom" offset={[15, 20]} opacity={1}>
                {marker.imei}
            </Tooltip>
        </RotatedMarker>
    );
}

export default React.memo(ConsoleMapMarker, (prevProps, nextProps) => {
    return (
        prevProps.marker.lat === nextProps.marker.lat &&
        prevProps.marker.lng === nextProps.marker.lng &&
        prevProps.marker.yaw === nextProps.marker.yaw &&
        prevProps.isOnline === nextProps.isOnline &&
        prevProps.onClick === nextProps.onClick
    );
});
